import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../types';
import { ConfigService } from './util/config.service';
import { PassportUser } from '../types/passport/passport-user';
import { BaseRequestService } from './util/base-request.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);

  #authUrl = inject(ConfigService).apiConfig.authUrl;
  #passportUrl = inject(ConfigService).externalApiConfig.passportUrl;
  #baseRequestService = inject(BaseRequestService);

  getUserData<T = User>(): Observable<T> {
    return this.http.get<T>(this.#baseRequestService.prepareUrl([this.#authUrl, 'user']));
  }

  getPassportUserData<T = PassportUser>(): Observable<T> {
    return this.http.get<T>(`${this.#passportUrl}/api/v1/passport/user_data/`);
  }
}
